
(() => {
  'use strict';

  if (window.CdiScrollLock) return;

  const OVERLAYS = {
    'header-drawer': () => {
      const el = document.querySelector('.cdi-header__drawer');
      return !!el && el.dataset.open === 'true';
    },
    'search-modal': () => {
      const el = document.getElementById('cdi-search-panel');
      return !!el && el.dataset.open === 'true';
    },
    'cart-drawer': () => {
      const el = document.querySelector('cart-drawer');
      return !!el && el.classList.contains('active');
    },
    chat: () => {
      const el = document.querySelector('[data-cdi-chat-shell]');
      return !!el && el.classList.contains('is-open');
    },
  };
  const RECONCILE_DELAY_MS = 400;
  const ATTR = 'data-cdi-scroll-locked-by';

  const _owners = new Set();
  let _scrollY = 0;
  let _active = false;
  let _reconcileTimer = null;

  function sync() {
    if (_owners.size) {
      document.documentElement.setAttribute(ATTR, Array.from(_owners).join(','));
    } else {
      document.documentElement.removeAttribute(ATTR);
    }
  }

  function apply() {
    _scrollY = window.scrollY;
    document.documentElement.style.overflowY = 'hidden';
    document.documentElement.style.touchAction = 'none';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    _active = true;
  }

  function release() {
    document.documentElement.style.overflowY = '';
    document.documentElement.style.touchAction = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    if (_active) {
      window.scrollTo(0, _scrollY);
    }
    _active = false;
  }

  function scheduleReconcile() {
    window.clearTimeout(_reconcileTimer);
    _reconcileTimer = window.setTimeout(() => {
      let changed = false;
      _owners.forEach((id) => {
        const check = OVERLAYS[id];
        if (check && !check()) {
          _owners.delete(id);
          changed = true;
        }
      });
      if (changed) sync();
      if (!_owners.size && _active) release();
    }, RECONCILE_DELAY_MS);
  }

  window.CdiScrollLock = {
    lock(ownerId) {
      _owners.add(ownerId);
      sync();
      if (_owners.size && !_active) apply();
      scheduleReconcile();
    },
    unlock(ownerId) {
      _owners.delete(ownerId);
      sync();
      if (!_owners.size && _active) release();
      scheduleReconcile();
    },
    forceUnlock() {
      _owners.clear();
      sync();
      release();
    },
    getScrollY() {
      return _active ? _scrollY : window.scrollY;
    },
    debugOwners() {
      return Array.from(_owners);
    },
  };
})();
